@if (!legendService.isLegendOpen()) {
    <button
        class="legend-btn"
        color="bg-background"
        mat-flat-button
        [matTooltip]="'legend' | transloco"
        (click)="toggleLegend()">
        <fa-icon [icon]="['fas', 'list']" />
    </button>
}
<div
    class="p-3 bg-white rounded-xl min-w-80 max-w-80 absolute top-0 left-0 z-10 flex flex-col min-h-0 gap-4"
    [class]="isContentOpenUnder() ? 'max-h-40' : 'max-h-96'"
    [class.hidden]="!legendService.isLegendOpen()">
    <div class="flex flex-row gap-2 items-center">
        <fa-icon
            class="font-medium text-secondary hover:text-primary transition-colors cursor-pointer"
            size="xl"
            [icon]="['far', 'arrow-left']"
            [matTooltip]="'back' | transloco"
            (click)="toggleLegend()" />
        <h2 class="!m-0 !font-medium text-lg">{{ 'legend' | transloco }}</h2>
    </div>
    <div class="grow overflow-auto overflow-x-hidden">
        <app-legend-list />
    </div>
</div>
